import {ApckPortletTable} from "../portlet";

export const ApckPortletUnfixedTable = /*#__PURE__*/ ApckPortletTable.extend({
    props: {
        ctype: {
            type: String,
            default: "unfixedtableportlet"
        },
        title: {
            type: String,
            default: "Unfixed Vulnerabilities"
        },
        size: {
            type: String,
            default: "lg"
        },
        description: {
            type: String,
            default: "Table showing the amounts and types of unfixed vulns"
        },
        src: {
            type: String,
            default: "/unfixedvulns"
        },
        limit: {
            type: Number,
            default: 5
        },
        sglRowAction: {
            type: Function,
            default: function (rec) {
                const labelMap = {
                    'critical': '5.0-critical',
                    'high': '4.0-high',
                    'medium': '3.0-medium',
                    'low': '2.0-low',
                    'info': '1.0-info',
                }
                const severity = rec.get('severity').toLowerCase();
                if (this.$globalFlags.spa) {
                    return this.$router.push({
                        name: 'vulnerabilities',
                        params: {
                            impact: labelMap[severity]
                        }
                    });
                } else {
                    const params = new URLSearchParams({
                        impact: labelMap[severity]
                    });
                    const href = '/vulnerabilities?' + params.toString();
                    window.open(href, '_blank').focus();
                }
            },
        },
        cols: {
            type: Array,
            default: () => [
                {heading: "Severity", data: "severity", canSearch: false},
                {heading: "Count", data: "unfixed_count", width: 80, canSearch: false, right: true}
            ]
        },
    },
});
